<template>
  <Layout>
    <div class="row">
      <PageHeader :title="title" class="col-6" />
      <div class="d-print-none col-6">
        <div class="float-end">
          <a
            href="javascript:window.print()"
            class="btn btn-success waves-effect waves-light me-1"
            ><i class="fa fa-print" style="margin-right: 10px"></i>Print</a
          >
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="invoice-title">
              <div class="mb-4">
                <h4>Incident Summary</h4>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-3">
                <p>Start Date:</p>
                <p>End Date:</p>
              </div>
              <div class="col-6 text-center">
                <h4>Incident Details Summary</h4>
              </div>
            </div>
            <hr />
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

/**
 * Invoice-detail component
 */
export default {
  page: {
    title: "Report Details",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Incident Summary",
    };
  },
};
</script>